import React from 'react';
export function GabrielBio() {
  return <section className="py-12 px-4 bg-dark-100" data-id="element-102">
      <div className="max-w-[680px] mx-auto" data-id="element-103">
        <p className="text-[13px] uppercase tracking-[0.1em] text-gold text-center mb-3" data-id="element-104">
          El Creador
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-body" data-id="element-105">
          ¿Quién es el hombre detrás de este protocolo?
        </h2>

        <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-106">
          <div className="w-full md:w-1/3 flex justify-center shrink-0" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/54YEKsE2AGnQCQ854v599M/Gabriel_Beltran_Profile_Pic.jpg" alt="Gabriel Beltrán" className="w-48 h-48 md:w-64 md:h-64 object-cover rounded-full ring-2 ring-gold/60 ring-offset-2 ring-offset-dark-100" data-id="element-108" />
          </div>

          <div className="w-full md:w-2/3 space-y-[12px] text-base text-body leading-[1.5] text-center md:text-left" data-id="element-109">
            <p data-id="element-110">
              Gabriel Beltrán no llegó aquí desde una vida perfecta. Llegó desde
              el mismo lugar donde probablemente estás tú ahora.
            </p>

            <p data-id="element-111">
              Conocido como{' '}
              <span className="text-gold font-semibold" data-id="element-112">
                @theecommillionaire
              </span>
              , construyó su libertad financiera desde cero — pero no antes de
              atravesar sus propios períodos de caos mental y pérdida.
            </p>

            <p data-id="element-113">
              Lo que descubrió no estaba en ningún libro.{' '}
              <span className="text-white font-medium" data-id="element-114">
                Lo descubrió en su propio sistema nervioso.
              </span>
            </p>

            <p className="font-serif italic text-base text-sage mt-4" data-id="element-115">
              The Reset Protocol no es un producto que Gabriel creó para vender.
              Es el protocolo que creó para sobrevivir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}